export default __webpack_public_path__ + "static/media/02.ecf9c55a.jpg";